import React from 'react';
import classnames from 'classnames';

import Section from '../../02-molecules/Section/Section';

import './BlogPostTeasersList.css';

const BlogPostTeasersList = ({
  children,
  className,
  layout,
  title,
  semanticLevel = 1,
}) => {
  if (!children) {
    return false;
  }

  return (
    <Section
      className={classnames(`BlogPostTeasersList`, className, {
        'BlogPostTeasersList--hero': layout === `hero`,
        'BlogPostTeasersList--further-reading': layout === `further-reading`,
        'BlogPostTeasersList--irregular-grid': layout === `irregular-grid`,
        'BlogPostTeasersList--simple': layout === `simple`,
      })}
      semanticLevel={semanticLevel}
      title={title}
    >
      <div className="BlogPostTeasersList__body">{children}</div>
    </Section>
  );
};

export default BlogPostTeasersList;
